(function($) {
  var currentMarkerControl = null;
  var initScalabelFigure = function(image, $parent, props) {
    var classNameBase = "c-scalableFigure";
    var buttonsPostfix = "__buttons";
    var buttonPostfix = "__button";
    var zoominClassName = "is-zoomin";
    var zoomoutClassName = "is-zoomout";
    var tasks = {};
    var area = $parent.data("mapArea");
    var markerPath = OH.settings.scalabelFigureDefine.pinPath + OH.settings.scalabelFigureDefine.pin4area['default'];
    // var markerPath = OH.settings.scalabelFigureDefine.pinPath + ((!!area && !!OH.settings.scalabelFigureDefine.pin4area[area]) ? OH.settings.scalabelFigureDefine.pin4area[area] : OH.settings.scalabelFigureDefine.pin4area['none']);

    var markerAnimationable = true;

    var transitionProp = OH.transitionalStyleProperty("transition", "_");
    var transformProp = OH.transitionalStyleProperty("transform", "_");
    var transformOriginProp = OH.transitionalStyleProperty("transform-origin", "_");

    var aspectRatio = image.naturalHeight / image.naturalWidth;

    var initialized = false;

    var offsetRate = (!!props && props.offset) ? props.offset : 1;
    var keepAspectRate = (!!props && props.keepAspectRate !== undefined) ? props.keepAspectRate : true;

    // var movableRate = (!!props && props.movable) ? props.movable : 0.5;
    var movableRate = 0.5;

    var stepLength = 4;
    var maxScale = 1;
    var minScale = offsetRate * $parent.width() / image.naturalWidth;
    var baseStep = Math.pow(maxScale / minScale, 1 / stepLength);
    var level = (!!props && props.level) ? props.level : 0;
    var defaltSteps = 3;
    var scale = maxScale * Math.pow(baseStep, level - stepLength);

    var offset = {
      x: Math.round($parent.width() * movableRate) * scale,
      y: Math.round($parent.height() * movableRate) * scale
    };
    var centerPixel = {
      x: Math.round($parent.width() / 2),
      y: Math.round($parent.height() / 2)
    };
    var centerCoord = {
      x: Math.round(image.naturalWidth / 2),
      y: Math.round(image.naturalHeight / 2)
    };
    var markerProps = (!!props && !!props.marker) ? props.marker : null;
    var currentCoord = !!markerProps ? {
      x: markerProps.x,
      y: markerProps.y
    } : {
      x: centerCoord.x,
      y: centerCoord.y
    };

    var $layer = (function() {
      var $div = $('<div>');
      $div.append($(image));
      $div.css({
        position: "relative",
        top: "0px",
        left: "0px",
        display: "inline-block"
      });
      $div.css(transformOriginProp, "0px 0px");
      return $div;
    })();

    var $overlay = (function() {
      var $div = $('<div>');
      $div.css({
        position: "absolute",
        top: "0px",
        left: "0px",
        display: "block"
      });
      $div.css(transformOriginProp, "0px 0px");
      return $div;
    })();

    var $pad = (function() {
      var $div = $('<div>');
      $div.append($layer);
      $div.append($overlay);
      $div.css({
        position: "relative",
        top: "0px",
        left: "0px",
        display: "inline-block"
      });
      $div.css(transformOriginProp, "0px 0px");
      return $div;
    })();

    var hasDefaultMarker;

    tasks.createMarker = function(force) {
      if (!markerProps || (!force && !area)) {
        hasDefaultMarker = false;
        return $('<span>');
      }
      if (hasDefaultMarker === undefined) {
        hasDefaultMarker = true;
      }

      var $wrap = $('<div>').css({
        width: "1px",
        height: "1px",
        display: "block",
        position: "absolute",
        top: "0px",
        left: "0px",
        overflow: "visible"
      });

      var pinImage = document.createElement("img");
      var $pinImage = $(pinImage).css({
        position: "relative",
        "pointer-events": "none"
      });

      pinImage.onload = function() {
        var w = markerProps.width ? markerProps.width : pinImage.naturalWidth;
        var h = markerProps.height ? markerProps.height : pinImage.naturalHeight;
        var ox = markerProps.offsetX ? (markerProps.offsetX - 0) : 0;
        var oy = markerProps.offsetY ? (markerProps.offsetY - 0) : 0;
        $pinImage.css({
          width: w + "px",
          height: h + "px",
          top: -h + oy + "px",
          left: -Math.round(w / 2) + ox + "px",
        });
      };
      pinImage.src = markerPath;
      return $wrap.append($pinImage);
    };

    var $marker = tasks.createMarker();

    $overlay.append($marker);

    tasks.activateMarkerAnimation = function(flag) {
      markerAnimationable = flag;
    };

    tasks.setMarkerPosition = function(force, elasticModulus) {
      if (!markerProps) {
        return;
      }
      if (!force && !!$marker.data("shown")) {
        $marker.css(transformProp, "translate(" + markerProps.x * scale + "px," + markerProps.y * scale + "px)");
        return;
      }
      $marker.data("shown", true);
      tasks.activateMarkerAnimation(true);

      var x = markerProps.x * scale;
      var y = markerProps.y * scale;
      var h = y + offset.y;
      var l = 150;
      var t = 0;
      var theta = Math.PI / 2;

      var motion = function() {
        t += 1;
        theta = (theta + 0.006 * Math.PI * Math.pow(t, 0.4));
        if (theta >= Math.PI) {
          theta %= Math.PI;
          l *= elasticModulus !== undefined ? elasticModulus : (1 / 3);
        }
        y = h - l * Math.abs(Math.sin(theta));
        if (!markerAnimationable || h - y < 0.05) {
          $marker.css(transformProp, "translate(" + x + "px," + markerProps.y * scale + "px)");
        } else {
          $marker.css(transformProp, "translate(" + x + "px," + (y - offset.y) + "px)");
          window.requestAnimationFrame(motion);
        }
      };
      motion();
    };

    tasks.setExtMarker = function(x, y) {
      $marker.remove();
      markerPath = OH.settings.scalabelFigureDefine.pinPath + OH.settings.scalabelFigureDefine.pin4area['none'];
      markerProps = {
        x: x,
        y: y,
        width: OH.settings.scalabelFigureDefine.pinSize.width,
        height: OH.settings.scalabelFigureDefine.pinSize.height,
        offsetX: OH.settings.scalabelFigureDefine.pinSize.offsetX,
        offsetY: OH.settings.scalabelFigureDefine.pinSize.offsetY
      }
      $marker = tasks.createMarker(true);
      $overlay.append($marker);
      tasks.setMarkerPosition(true, 0);

    };

    var $buttons = $('<div>').addClass(classNameBase + buttonsPostfix);

    var $zoomInButton = (function() {
      var btn = $('<div>').addClass(classNameBase + buttonPostfix + " " + zoominClassName);
      return btn;
    })();
    var $zoomOutButton = (function() {
      var btn = $('<div>').addClass(classNameBase + buttonPostfix + " " + zoomoutClassName);
      return btn;
    })();

    $buttons.append($zoomInButton).append($zoomOutButton)
    $parent.append($buttons);

    tasks.setZoom = function(reqLevel, force) {
      ($zoomInButton[reqLevel == stepLength ? "addClass" : "removeClass"])("is-disabled");
      ($zoomOutButton[reqLevel == 0 ? "addClass" : "removeClass"])("is-disabled");

      if (!force && level == reqLevel) {
        return;
      }
      level = reqLevel;
      scale = minScale * Math.pow(baseStep, level);
      $overlay.css("display", "none");

      tasks.setPosition(currentCoord.x, currentCoord.y);
      window.setTimeout(function() {
        $overlay.css("display", "block");
      }, 500)
    };

    tasks.setCenterCoord = function(x, y, ignore) {
      currentCoord.x = ignore ? x : Math.max(0, Math.min(image.naturalWidth, x));
      currentCoord.y = ignore ? y : Math.max(0, Math.min(image.naturalHeight, y));
    };

    tasks.increaseScale = function(flag) {
      tasks.switchAnimation(true, null, null, true);
      tasks.setZoom(Math.min(stepLength, Math.max(0, level + (flag ? 1 : (-1)))));
    }

    tasks.setPosition = function(coordX, coordY) {
      tasks.activateMarkerAnimation(false);
      $layer.css(transformProp, "scale(" + scale + ")");
      $pad.css(transformProp, "translate(" + (centerPixel.x - coordX * scale) + "px," + (centerPixel.y - coordY * scale) + "px)");
      tasks.setMarkerPosition();
    };

    currentMarkerControl = function() {
      tasks.setCenterCoord(markerProps.x, markerProps.y);
      tasks.setZoom(level, true);
      window.setTimeout(function() {
        tasks.setMarkerPosition(true);
      }, 300);
    };

    tasks.switchAnimation = function(flag, type, dur, soon) {
      flag = initialized ? flag : false;
      if (flag) {
        var exec = function() {
          $pad.css(transitionProp, transformProp + " " + (!!dur ? dur : 200) + "ms " + (!!type ? type : "linear"));
          $layer.css(transitionProp, transformProp + " " + (!!dur ? dur : 200) + "ms linear");
        };

        if (soon) {
          exec();
        } else {
          window.requestAnimationFrame(exec);
        }
      } else {
        $pad.css(transitionProp, "none");
        $layer.css(transitionProp, "none");
      }
    };

    $parent.css({
      "overflow": "hidden",
      position: "relative",
      top: "0px",
      left: "0px"
    });
    $parent.append($pad);

    var onresize = function() {
      if (keepAspectRate) {
        $parent.height($parent.width() * aspectRatio);
      }
      offset = {
        x: Math.round($parent.width() * movableRate) * scale,
        y: Math.round($parent.height() * movableRate) * scale
      };
      centerPixel = {
        x: Math.round($parent.width() / 2),
        y: Math.round($parent.height() / 2)
      };
      centerCoord = {
        x: Math.round(image.naturalWidth / 2),
        y: Math.round(image.naturalHeight / 2)
      };
    };

    var dragging = null;
    var gesturing = null;

    var gestureValues = function(touches) {
      var coords = new Array();
      for (var i = 0; i < touches.length; i++) {
        coords.push({
          x: touches[i].pageX,
          y: touches[i].pageY
        });
      }
      var center = {
        x: 0,
        y: 0
      };
      for (var i = 0; i < coords.length; i++) {
        center.x += coords[i].x / coords.length;
        center.y += coords[i].y / coords.length;
      }
      var magnitude = 0;
      for (var i = 0; i < coords.length; i++) {
        magnitude += Math.pow(Math.pow(center.x - coords[i].x, 2) + Math.pow(center.y - coords[i].y, 2), 1 / 2) / coords.length;
      }
      return {
        center: center,
        magnitude: magnitude
      };
    };

    var ongestureend = function(event) {
      event.preventDefault();
      gesturing = null;
      dragging = null;
      tasks.setCenterCoord(currentCoord.x, currentCoord.y);
      tasks.setZoom(Math.round(level));
    };

    var ongesture = function(event) {
      event.preventDefault();

      if (event.originalEvent.touches.length < 2) {
        return;
      }
      var gv = gestureValues(event.originalEvent.touches);
      var sc = gv.magnitude / gesturing.m;

      var newLevel = Math.max(Math.min(gesturing.level + Math.log(sc) / Math.log(baseStep), stepLength), 0);

      if (newLevel == gesturing.level) {
        return;
      }

      var figpos = $parent.offset();
      var ds = Math.pow(baseStep, stepLength - level) - Math.pow(baseStep, stepLength - newLevel);
      var dx = gv.center.x - figpos.left - centerPixel.x;
      var dy = gv.center.y - figpos.top - centerPixel.y;

      tasks.setCenterCoord(currentCoord.x + dx * ds, currentCoord.y + dy * ds, true);
      tasks.setZoom(newLevel);
    };


    var ondragstart = function(event) {
      event.preventDefault();
      var offsetParent = $parent.offset();
      dragging = {
        startX: !!event.originalEvent.touches ? (event.originalEvent.touches[0].pageX - offsetParent.left) : event.clientX,
        startY: !!event.originalEvent.touches ? (event.originalEvent.touches[0].pageY - offsetParent.top) : event.clientY,
        path: new Array()
      }
      tasks.switchAnimation(false);
      return false;
    };

    var ondrag = function(event) {
      if (!!gesturing) {
        if (!!event.originalEvent.touches && event.originalEvent.touches.length < 2) {
          ongestureend(event);
        } else {
          ongesture(event);
        }
        return;
      }
      if (!dragging) {
        return;
      }
      event.preventDefault();
      if (!!event.originalEvent.touches && event.originalEvent.touches.length > 1) {
        var gv = gestureValues(event.originalEvent.touches);

        gesturing = {
          x: gv.center.x,
          y: gv.center.y,
          m: gv.magnitude,
          center: {
            x: currentCoord.x,
            y: currentCoord.y
          },
          level: level
        };
        $tileLayer.setAnimation(true);
        dragging = null;
        return false;
      }

      var offsetParent = $parent.offset();
      var x = !!event.originalEvent.touches ? (event.originalEvent.touches[0].pageX - offsetParent.left) : event.clientX;
      var y = !!event.originalEvent.touches ? (event.originalEvent.touches[0].pageY - offsetParent.top) : event.clientY;

      dragging.path.push({
        time: new Date().getTime(),
        x: currentCoord.x - (x - dragging.startX) / scale,
        y: currentCoord.y - (y - dragging.startY) / scale
      });

      tasks.setPosition(currentCoord.x - (x - dragging.startX) / scale, currentCoord.y - (y - dragging.startY) / scale);

      return false;
    };

    var dragPathMinLength = 4;
    var dragDeficitRate = 0.3;
    var transformDuration = 500;
    var ondragend = function(event) {
      if (!dragging) {
        return;
      }
      if (!!gesturing) {
        ongestureend(event);
        return;
      }
      event.preventDefault();

      var offsetParent = $parent.offset();
      var x = !!event.originalEvent.changedTouches ? (event.originalEvent.changedTouches[0].pageX - offsetParent.left) : event.clientX;
      var y = !!event.originalEvent.changedTouches ? (event.originalEvent.changedTouches[0].pageY - offsetParent.top) : event.clientY;
      tasks.setCenterCoord(currentCoord.x - (x - dragging.startX) / scale, currentCoord.y - (y - dragging.startY) / scale);

      tasks.setPosition(currentCoord.x, currentCoord.y);

      if (dragging.path.length >= dragPathMinLength && currentCoord.x != image.naturalWidth && currentCoord.x != 0 && currentCoord.y != image.naturalHeight && currentCoord.y != 0) {
        tasks.switchAnimation(true, "ease-out", transformDuration, true);
        var now = new Date().getTime();
        var previousPath = dragging.path[dragging.path.length - dragPathMinLength];
        var velocity = {
          x: (currentCoord.x - previousPath.x) / (now - previousPath.time),
          y: (currentCoord.y - previousPath.y) / (now - previousPath.time)
        };
        var extraTranslate = {
          x: dragDeficitRate * transformDuration * velocity.x,
          y: dragDeficitRate * transformDuration * velocity.y
        };
        tasks.setCenterCoord(currentCoord.x + extraTranslate.x, currentCoord.y + extraTranslate.y);
        tasks.setPosition(currentCoord.x, currentCoord.y);
        window.setTimeout(function() {
          tasks.switchAnimation(true);
        }, transformDuration);
      } else {
        tasks.switchAnimation(true);
      }
      dragging = null;
      return false;
    };

    var wheeling = null;
    var ondomscroll = function(event) {
      event.preventDefault();
      if (!wheeling) {
        wheeling = {
          timer: null,
          scale: scale
        }
      }
      var figpos = $parent.offset();
      var delta = !!event.originalEvent.wheelDelta ? event.originalEvent.wheelDelta : !!event.originalEvent.detail ? (-event.originalEvent.detail) : 0;
      var newLevel = Math.min(stepLength, Math.max(0, level + (delta > 0 ? 1 : (-1))));

      var ds = Math.pow(baseStep, stepLength - level) - Math.pow(baseStep, stepLength - newLevel);
      var dx = event.originalEvent.pageX - figpos.left - centerPixel.x;
      var dy = event.originalEvent.pageY - figpos.top - centerPixel.y;

      tasks.switchAnimation(true);
      tasks.setCenterCoord(currentCoord.x + dx * ds, currentCoord.y + dy * ds);
      tasks.setZoom(newLevel);

    };

    onresize();
    tasks.setPosition(currentCoord.x, currentCoord.y);
    tasks.setZoom(level);
    tasks.switchAnimation(true);

    $(window).on("resize", onresize);

    $parent.on("mousedown touchstart", ondragstart);
    $(document.body).on("mousemove touchmove", ondrag);
    $parent.on("mouseup mouseout touchend", ondragend);
    $parent.on("mousewheel DOMMouseScroll", ondomscroll);

    $zoomInButton.on("mousedown touchstart", function(event) {
      event.stopPropagation();
    });
    $zoomInButton.on("click", function(event) {
      event.stopPropagation();
      event.preventDefault();
      tasks.increaseScale(true);
    });

    $zoomOutButton.on("mousedown touchstart", function(event) {
      event.stopPropagation();
    });
    $zoomOutButton.on("click", function(event) {
      event.stopPropagation();
      event.preventDefault();
      tasks.increaseScale(false);
    });
    initialized = true;

    // --------------------

    var $coordInfoArea = null;
    var setCoordInfoArea = function() {
      if (!!$coordInfoArea) {
        $coordInfoArea.html("")
        return;
      }
      var $wrap = $('<div>').css({
        position: "relative",
        width: "100%",
        height: "0px",
        overflow: "visible"
      });
      $coordInfoArea = $('<div>').css({
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "100%",
        height: "30px"
      });
      $parent.after($wrap.append($coordInfoArea));
    };

    $(image).on("click", function(event) {
      //windwos判別 ctrl or command keyが押されてなかったら処理抜ける
      if (navigator.platform.indexOf("Win") != -1) {
        if (!event.ctrlKey) {
          return;
        }
      } else {
        if (!event.metaKey) {
          return;
        }
      }
      if (hasDefaultMarker) {
        return;
      }
      var x = Math.round(event.offsetX + 1 / scale);
      var y = Math.round(event.offsetY + 1 / scale);
      tasks.setExtMarker(x, y);

      setCoordInfoArea();

      var $input = $('<input>').attr("type", "text").val(x + "," + y);
      $coordInfoArea.append($input)
      $input.select();

      var success = false;
      try {
        success = document.execCommand("copy");
      } catch (e) {
        success = false;
      }

      if (success) {
        $coordInfoArea.html('位置座標 "' + x + ',' + y + '"をクリップボードにコピーしました');
      } else {
        $input.before($('<span>').text("位置座標："));
      }
    });

  };

  var createModalBox = function(props) {
    var $panel = $('<div>').addClass("c-infoModal");
    var $title = $('<div>').addClass("c-infoModal__title").append($('<span>').text(props.text));
    var $content = $('<div>').addClass("c-infoModal__content c-scalableFigure");
    var $caption = $('<div>').addClass("c-infoModal__caption");
    var $topflow = $('<div>').addClass("c-infoModal__topflow");

    var lang = document.documentElement.getAttribute("lang") || "ja";
    var src = OH.settings.scalabelFigureDefine.mapfigurePath + OH.settings.scalabelFigureDefine.figname["default"] + "/" + OH.settings.scalabelFigureDefine.mapfigures[props.figType] + '.png';

    $content.data("figureSrc", src);
    $content.data("mapArea", props.mapArea);
    $panel.append($title).append($content).append($caption).append($topflow);
    return {
      panel: $panel,
      content: $content,
      caption: $caption,
      topflow: $topflow
    };
  };

  
  var control = {
    // ■■■ floor_mapの言語取得して生成部分
    indexMapLang: function($parent){
      var langMode;
      function mapSrcChanges(langMode){
        var defaultImageName = 'ja';
        var mapLang = (langMode == defaultImageName) ? 'jp' : langMode;
        var mapSrc = '/floor_map/images/index/' + mapLang +'.png';
        $parent.attr('src',mapSrc);
      }
      try{
        window.addEventListener('wovnApiReady', function(evt) {
          langMode = WOVN.io.getCurrentLang().code || 'ja';
          mapSrcChanges(langMode);
        });
        window.addEventListener('wovnLangChanged', function(evt) {
          langMode = WOVN.io.getCurrentLang().code || 'ja';
          mapSrcChanges(langMode);
        });
      }catch(elseFlg){
        console.warn('wovn load error. this message by local script.');
        langMode = 'ja';
        mapSrcChanges(langMode);
      }

    },

    mapImageSrc: function($parent,langMode,props){
      var defaultImageName = OH.settings.scalabelFigureDefine.figname["ja"];
      var lang = langMode;
      var translatedImageName;
      translatedImageName = OH.settings.scalabelFigureDefine.figname[lang];
      var image = document.createElement("img");
      image.className = 'map_image';
      image.onload = function() {
          initScalabelFigure(image, $parent, props);
          image.onload = null; // 二回発火防止
      };
      image.src = (function() {
          var inpSrc = $parent.data("figureSrc");
          return defaultImageName == translatedImageName ? inpSrc : inpSrc.replace(defaultImageName, translatedImageName);
      })();
    },

    setFigure: function($parent, props) {
      var loadedFunc = function () {
        var url = window.location.pathname.split('/');
        var getLangMode = function (str) {
          var l = '';
          switch(str) {
            case 'en':
            case 'zh-CHS':
            case 'zh-CHT':
            case 'ko':
              l = str;
              break;
            default:
              l = 'ja';
              break;
          }
          return l;
        };
        window.removeEventListener('DOMContentLoaded', loadedFunc, false);
        control.mapImageSrc($parent,getLangMode(url[1]),props);
      };
      window.addEventListener('DOMContentLoaded', loadedFunc, false);      
      window.addEventListener('wovnLangChanged', function(evt) {
        langMode = WOVN.io.getCurrentLang().code|| 'ja';
        var $mapElm = document.getElementsByClassName('map_image');
        // var $mapFig = document.getElementsByClassName('c-scalableFigure');
        if($mapElm.length > 0){
          $('.c-scalableFigure').css('height','').children().remove();// jquery から　scratchに修正する
        }
        control.mapImageSrc($parent,langMode,props);
      });
      // window.addEventListener('wovnLangChanged', control.mapImageSrc($parent,props));
    },
    setModal: function($parent) {
      $parent.on("click", function(event) {
        var figTypeData = $parent.data("locationFigure");
        if (!OH.settings.scalabelFigureDefine.mapfigures[figTypeData]) {
          $parent.attr("href", OH.settings.scalabelFigureDefine.mapfigureTop);
          return;
        }
        var coordData = $parent.data("locationCoord");
        if (!coordData) {
          return;
        }
        event.preventDefault();
        var $modal = OH.modalController.maxsizeModal();
        var modalBox = createModalBox({
          text: $parent.text(),
          href: $parent.attr("href"),
          mapArea: $parent.data("mapArea"),
          figType: figTypeData
        });

        $modal.parent().addClass("is-full");

        if ($modal.width() > $(window).width()) {
          $modal.width($(window).width() - 30);
        }
        if ($modal.height() > $(window).height()) {
          $modal.height($(window).height() - 30);
        }

        $modal.append(modalBox.panel);

        if (modalBox.content.height() == 0) {
          modalBox.content.height($(window).height() - 200);
        }

        var coord = (function() {
          //	var c = $parent.data("locationCoord");
          //	if(!c){
          //		return {};
          //	}
          coordData = coordData.split(",");
          return {
            x: coordData[0] - 0,
            y: coordData[1] - 0
          };
        })();
        
        try{
          var langMode = WOVN.io.getCurrentLang().code;
        }catch(elseFlg){
          var langMode = 'ja';
        }

        
        control.mapImageSrc(modalBox.content,langMode, {
          offset: 0.8,
          level: 0, // 最初のzoomレベル
          keepAspectRate: false,
          marker: {
            x: coord.x,
            y: coord.y,
            width: OH.settings.scalabelFigureDefine.pinSize.width,
            height: OH.settings.scalabelFigureDefine.pinSize.height,
            offsetX: OH.settings.scalabelFigureDefine.pinSize.offsetX,
            offsetY: OH.settings.scalabelFigureDefine.pinSize.offsetY
          }
        });
        var $captionElement = (function() {
          var $anc = $('<a>').text($parent.data("locationName")).addClass("is-location");
          $anc.on("click", function(event) {
            event.preventDefault();
            if (typeof currentMarkerControl == "function") {
              currentMarkerControl();
            }
          });
          $anc.attr("href", location.href);
          return $anc;
        })();

        var $topflowElement = $('<a>').text(OH.settings.scalabelFigureDefine.topflow.text).attr("href", OH.settings.scalabelFigureDefine.topflow.href);

        modalBox.caption.html(OH.settings.scalabelFigureDefine.locationIcon).append($captionElement);
        modalBox.topflow.append($topflowElement);

      });
    }
  };

  OH.settings.scalabelFigureControl = control;

})(jQuery);
